import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import { createData, getListData } from "../../hooks/api/utils";

const Setting = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    referred_by: "",
    referred_to: "",
  });
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    setLoading(true);
    getListData("/admin-panel/settings/", setLoading, (data) => {
      setFormData({
        referred_by: data?.data?.referred_by || "",
        referred_to: data?.data?.referred_to || "",
      });
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (section, e) => {
    e.preventDefault();
    const errors = {};
    if (section === "referral") {
      if (formData.referred_by === "") {
        errors.referred_by = "Referral bonus is required";
      } else if (isNaN(formData.referred_by) || Number(formData.referred_by) < 0) {
        errors.referred_by = "Referral bonus must be a non-negative number";
      }
      if (formData.referred_to === "") {
        errors.referred_to = "Reward bonus is required";
      } else if (isNaN(formData.referred_to) || Number(formData.referred_to) < 0) {
        errors.referred_to = "Reward bonus must be a non-negative number";
      }
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setLoading(true);
      const payload = {
        referred_by: Number(formData.referred_by),
        referred_to: Number(formData.referred_to),
      };

      createData("/admin-panel/settings/", setLoading, payload, navigate, "/dashboard");
    }
  };

  return (
  
      <div className="rightContent">
        <div className="doc_info">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="padding-inner border-radius-20 bg-white shadow-sm">
                <h4 className="mb-4">Settings</h4>

                <div className="accordions modern-accordion" id="settingsAccordion">
                  {/* Referral Accordion */}
                  <div className="accordion-item border-0 mb-3 shadow-sm rounded overflow-hidden p-3">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button d-flex justify-content-between"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="true"
                        aria-controls="collapseTwo"
                      >
                        <span>Bonus Points</span>
                        <i className="chevron-icon"></i>
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#settingsAccordion"
                    >
                      <div className="accordion-body">
                        <form onSubmit={(e) => handleSubmit("referral", e)}>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Referral Bonus(%)</label>
                                <input
                                  type="text"
                                  name="referred_by"
                                  value={formData.referred_by}
                                  onChange={handleChange}
                                  placeholder="Enter your Referral Commission"
                                  className="form-control"
                                />
                                {formErrors.referred_by && (
                                  <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                                    {formErrors.referred_by}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Reward Bonus(%)</label>
                                <input
                                  type="text"
                                  name="referred_to"
                                  value={formData.referred_to}
                                  onChange={handleChange}
                                  placeholder="Enter your Referral Benefit"
                                  className="form-control"
                                />
                                {formErrors.referred_to && (
                                  <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                                    {formErrors.referred_to}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex gap-3 justify-content-end mt-3">
                            <Link to="/dashboard" className="transparent_btn ">
                              Cancel
                            </Link>
                            <button type="submit" className="blue_btn">
                              Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Setting;
